import { useEffect, useState } from "react";
import { getBranding } from "../api";

const DEFAULTS = {
  company_name: "PhotonPE",
  name_primary: "PHOTON",
  name_accent: "PE",
  tagline: "APKA APNA BANKING PARTNER",
  logo: "",
  primary_color: "#0D1B2A",
  accent_color: "#06B6D4",
  accent2_color: "#10B981",
};

let cache = null;
let inflight = null;

const applyTheme = (b) => {
  const r = document.documentElement.style;
  r.setProperty("--pp-navy", b.primary_color);
  r.setProperty("--pp-orange", b.accent_color);
  r.setProperty("--pp-orange-light", b.accent2_color);
  r.setProperty("--brand-primary", b.primary_color);
  r.setProperty("--brand-accent", b.accent_color);
  r.setProperty("--brand-accent2", b.accent2_color);
  if (b.company_name) document.title = b.company_name;
};

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = getBranding()
      .then((d) => { cache = { ...DEFAULTS, ...d }; applyTheme(cache); return cache; })
      .catch(() => { applyTheme(DEFAULTS); return DEFAULTS; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export default function useBranding() {
  const [b, setB] = useState(cache || DEFAULTS);
  useEffect(() => {
    let m = true;
    load().then((x) => m && setB(x));
    return () => { m = false; };
  }, []);
  return b;
}
